import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { ContactInfoCard } from '../contact-info-card/ContactInfoCard'
import { AgendaDetail } from './AgendaDetail'

type AgendaContactSectionProps = {
  /** Heads the section, e.g. "Afspraak annuleren of wijzigen?". */
  title?: string
  /** Says who to call and why, under the title. */
  description?: string
  name: string
  phone: string
  /** Called when the patient taps the number; the page decides what to track. */
  onCall?: () => void
}

/**
 * Who to contact about an agenda item: a short heading over the contact card, which shows the name
 * over a tappable phone number with the call badge.
 */
const AgendaContactSection = ({ title, description, name, phone, onCall }: AgendaContactSectionProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space4}>
      {title || description ? (
        <FlexColumn gap={theme.UI.Spacing.Space1}>
          {title ? <AgendaDetail.SectionTitle>{title}</AgendaDetail.SectionTitle> : null}
          {description ? <AgendaDetail.Text>{description}</AgendaDetail.Text> : null}
        </FlexColumn>
      ) : null}
      <ContactInfoCard>
        <ContactInfoCard.Name type='BodyMediumBold'>{name}</ContactInfoCard.Name>
        <ContactInfoCard.Phone href={`tel:${phone}`} onClick={onCall}>
          <ContactInfoCard.PhoneNumber type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
            {phone}
          </ContactInfoCard.PhoneNumber>
          <ContactInfoCard.Icon icon={['fal', 'phone']} />
        </ContactInfoCard.Phone>
      </ContactInfoCard>
    </FlexColumn>
  )
}

export { AgendaContactSection }
